import React from 'react';
import { Avatar, Card, CardActionArea, CardContent, Typography, CardMedia, Box } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { apiBaseUrl } from '../utils/Api/Api';
import Pets from '@mui/icons-material/Pets';

/* Icons */
import CakeIcon from '@mui/icons-material/Cake';

const PetCard = ({ pet }) => {
  const navigate = useNavigate();

  /* Cálculo Niver Pet */
  const PetAge = (birthDate) => {
    if (!birthDate) return false;

    const today = new Date();
    const birthday = new Date(birthDate);

    let years = today.getFullYear() - birthday.getFullYear();
    let months = today.getMonth() - birthday.getMonth();

    if (months < 0 || (months === 0 && today.getDate() < birthday.getDate())) {
      years--;
      months += 12;
    }

    if (years >= 1) {
      return `${years} ${years === 1 ? 'ano' : 'anos'}`;
    }

    if (months >= 1) {
      if (today.getDate() >= birthday.getDate()) {
        return `${months} ${months === 1 ? 'mês' : 'meses'}`;
      } else {
        return `${months - 1} ${months - 1 === 1 ? 'mês' : 'meses'}`;
      }
    }

    return "Recém-nascido";
  };

  const containerFlex = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 1
  }

  const flexCenter = {
    display: 'flex',
    alignItems: 'center'
  }

  return (
    <Card sx={{ flexGrow: 1 }}>
      <CardActionArea
        data-no-shadow="true"
        onClick={() => navigate(`/mypets/${pet.id}/details`)}
        sx={{ display: 'block' }}
      >
        <Box sx={{ ...containerFlex, padding: '12px', gap: 2, gridRow: '1 / span 1', gridColumn: '1 / span 1' }}>
          {pet.avatar_url ? (
            <CardMedia
              component="img"
              image={`${apiBaseUrl}/${pet.avatar_url}`}
              sx={{ height: '128px', margin: 'auto', borderRadius: '16px' }}
            />
          ) : (
            <Avatar sx={{ height: '128px', width: '100%', margin: 'auto', borderRadius: '16px' }}>
              <Pets sx={{ width: '32px', height: '32px' }} />
            </Avatar>
          )}
          <CardContent sx={{ ...containerFlex, gap: 1, alignSelf: 'stretch', p: 0, pb: '0 !important' }}>
            <Typography variant="storeName" sx={{ alignSelf: 'stretch', textAlign: 'left', lineHeight: '20px' }}>
              {pet.name}
            </Typography>

            {/* Infos Pet */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', alignSelf: 'stretch' }}>

              {/* Idade Pet */}
              <Box sx={{ ...flexCenter, gap: 1 }}>
                {
                  PetAge(pet.birth_date) &&
                  <>
                    <CakeIcon sx={{ color: '#F8963E', width: '16px', height: '16px' }} />
                    <Typography sx={{ fontFamily: 'Nunito', fontSize: '14px', fontWeight: 700, lineHeight: '21px', color: '#546E7A' }}>
                      {PetAge(pet.birth_date)}
                    </Typography>
                  </>
                }
              </Box>
            </Box>
          </CardContent>
        </Box>
      </CardActionArea>
    </Card>
  );
}

export default PetCard
